import React from 'react'
import DfbCardDefault from '@dfb/gatsby-dfb-theme/src/components/elements/dfb_card'
import CCardNews from '@dfb/gatsby-dfb-theme/src/components/elements/c_card_news'

function DfbCard(props) {
  if (props.data.type === 'news') {
    return <CCardNews {...props} />
  }
  return <DfbCardDefault {...props} />
}

export default DfbCard
